import saveAs from "file-saver";

export const exportKpiCsv = (
    targetVsActualPR: any[],
    viewMode: string,
    selectedPeriod: string,
) => {
    if (!targetVsActualPR || !Array.isArray(targetVsActualPR)) return;

    const findMetric = (metricName: string) => {
        return (
            targetVsActualPR.find(
                (m: any) =>
                    m.Metrics && m.Metrics.toLowerCase() === metricName.toLowerCase(),
            ) || {
                Actual: 0,
                Target: 0,
                RR: 0,
                Proportional_Attainment: 0,
            }
        );
    };

    const metricsToExport = [
        { header: "SPEND", metric: "Spend", isCurrency: true, isPercentage: false },
        {
            header: "CLICKS",
            metric: "Clicks",
            isCurrency: false,
            isPercentage: false,
        },
        { header: "CVR", metric: "cvr", isCurrency: false, isPercentage: true },
        { header: "FTD", metric: "ftd", isCurrency: false, isPercentage: false },
        {
            header: "CPA INCOME",
            metric: "CPA_Income",
            isCurrency: true,
            isPercentage: false,
        },
        {
            header: "RS INCOME",
            metric: "RS_Income",
            isCurrency: true,
            isPercentage: false,
        },
        {
            header: "TOTAL INCOME",
            metric: "TOTAL_Income",
            isCurrency: true,
            isPercentage: false,
        },
        {
            header: "PROFIT",
            metric: "profit",
            isCurrency: true,
            isPercentage: false,
        },
        { header: "CPC", metric: "cpc", isCurrency: true, isPercentage: false },
        { header: "CAC", metric: "cac", isCurrency: true, isPercentage: false },
        { header: "NRPU", metric: "nrpu", isCurrency: true, isPercentage: false },
        {
            header: "CPA PV",
            metric: "CPA_PV",
            isCurrency: true,
            isPercentage: false,
        },
        { header: "RS PV", metric: "RS_PV", isCurrency: true, isPercentage: false },
        { header: "PV", metric: "pv", isCurrency: true, isPercentage: false },
    ];

    const formatVal = (
        val: number,
        isCurrency: boolean,
        isPercentage: boolean,
    ) => {
        if (isPercentage) {
            return `"${(val * 100).toFixed(2)}%"`;
        }
        const rounded = Math.round(val);
        const formatted = rounded.toLocaleString();
        return isCurrency ? `"${formatted}$"` : `"${formatted}"`;
    };

    const formatPercent = (val: number) => {
        return `"${(val * 100).toFixed(2)}%"`;
    };

    let csvContent = `\uFEFF`; // BOM for Excel

    // Headers
    const headers = ["", ...metricsToExport.map((m) => m.header)];
    csvContent += headers.join(",") + "\n";

    // Row 1: Actual
    const actualRow = ["Actual"];
    metricsToExport.forEach((m) => {
        const data = findMetric(m.metric);
        actualRow.push(formatVal(data.Actual, m.isCurrency, m.isPercentage));
    });
    csvContent += actualRow.join(",") + "\n";

    // Row 2: RR (Proportional Attainment)
    const rrRow = ["RR"];
    metricsToExport.forEach((m) => {
        const data = findMetric(m.metric);
        rrRow.push(formatPercent(data.Proportional_Attainment));
    });
    csvContent += rrRow.join(",") + "\n";

    // Row 3: Projection (Target)
    const projectionRow = ["Projection"];
    metricsToExport.forEach((m) => {
        const data = findMetric(m.metric);
        projectionRow.push(formatVal(data.Target, m.isCurrency, m.isPercentage));
    });
    csvContent += projectionRow.join(",") + "\n";

    // Row 4: Predicted RR (RR)
    const predictedRrRow = ["Predicted RR"];
    metricsToExport.forEach((m) => {
        const data = findMetric(m.metric);
        predictedRrRow.push(formatVal(data.RR, m.isCurrency, m.isPercentage));
    });
    csvContent += predictedRrRow.join(",") + "\n";

    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const filename = `KPI_and_RR_${viewMode}_${selectedPeriod.replace(/\s+/g, "_")}.csv`;
    saveAs(blob, filename);
};
